import * as AddressFormatter from '@shopify/address/build/ts/index';
import { Subscription } from '../App';

type ShippingAddressType = {
  address1: string;
  address2: string;
  city: string;
  company: string;
  countryCode: string;
  firstName: string;
  lastName: string;
  phone: string;
  provinceCode: string;
  zip: string;
  country: AddressFormatter.Country;
  countries: AddressFormatter.Country[];
};

export type { ShippingAddressType };

export const createShippingAddress = async (subscription: Subscription) => {
  const addressFormatter = new AddressFormatter.default('ja');

  return {
    address1: subscription.deliveryAddress1,
    address2: subscription.deliveryAddress2,
    city: subscription.deliveryCity,
    company: subscription.deliveryCompany,
    countryCode: subscription.deliveryCountryCode,
    firstName: subscription.deliveryFirstName,
    lastName: subscription.deliveryLastName,
    phone: subscription.deliveryPhone,
    provinceCode: subscription.deliveryProvinceCode,
    zip: subscription.deliveryZip,
    country: await addressFormatter.getCountry(subscription.deliveryCountryCode),
    countries: await addressFormatter.getCountries(),
  };
};
